import categoryService from "../../components/Services/category.service";
import energyService from "../../components/Services/energyType.service";
import specificationService from "../../components/Services/specification.service";
import controlAreaService from "../../components/Services/controlArea.service";
import subsidyTypeService from "../../components/Services/subsidyType.service";
import discomService from "../../components/Services/discom.service";
import gridConnectivity from "../../components/Services/gridConnectivity.service";
import voltageLevel from "../../components/Services/voltageLevel.service";
import regionService from "../../components/Services/region.service";
import stateCityService from "../../components/Services/stateCity.service";
import creditRatingService from "../../components/Services/creditRating.service";
import {
  SET_INITIAL_REQUIRED_DATA,
  IS_REGISTRATION_SUCCESS,
  STATE_OPTIONS,
  DISCOM_OPTIONS,
  DISCOM_CON_OPTIONS,
  STATE_CON_OPTIONS,
} from "./types";
import { apiCall } from "../../components/Services/Interceptor";
import { toast } from "react-toastify";
import pointOfDrawlService from "../../components/Services/pointOfDrawl.service";
import nationalityService from "../../components/Services/nationality.service";
import { toastProperties } from "../../commons/Toast/Toaster";
import holdingCompanyService from "../../components/Services/holdingCompany.service";
import axios from "axios";

export const initialCallForRequiredData = async ({ reqData, dispatch }) => {
  let result = {};
  try {
    let allHoldingCompanyList = (
      await holdingCompanyService.getAllHoldingCompanyList()
    )?.data;
    if (allHoldingCompanyList?.code == 200) {
      result.allHoldingCompanyList = allHoldingCompanyList.data;
    }
    let allCategoryTypes = (await categoryService.getAllCategory(reqData))
      ?.data;
    if (allCategoryTypes?.code == 200) {
      result.allCategoryTypes = allCategoryTypes.data;
    }
    let energyTypes = (await energyService.getAllEnegyType())?.data;
    if (energyTypes?.code == 200) {
      result.energyTypes = energyTypes.data;
    }
    let discomTypes = (await discomService.getAllDiscomName())?.data;
    if (discomTypes?.code == 200) {
      result.discomTypes = discomTypes.data;
    }
    let gridConnectivityTypes = (
      await gridConnectivity.getAllGridConnectivity()
    )?.data;
    if (gridConnectivityTypes?.code == 200) {
      result.gridConnectivityTypes = gridConnectivityTypes.data;
    }
    let voltageLevelTypes = (await voltageLevel.getAllVoltageLevel())?.data;
    if (voltageLevelTypes?.code == 200) {
      result.voltageLevelTypes = voltageLevelTypes.data;
    }
    let regionTypes = (await regionService.getAllRegion())?.data;
    if (regionTypes?.code == 200) {
      result.regionTypes = regionTypes.data;
    }
    let allStateTypes = (await stateCityService.getAllState())?.data;
    if (allStateTypes?.code == 200) {
      result.allStateTypes = allStateTypes.data;
    }
    let allCityTypes = (await stateCityService.getAllCity())?.data;
    if (allCityTypes?.code == 200) {
      result.allCityTypes = allCityTypes.data;
    }
    let allCreditRatings = (await creditRatingService.getAllCreditRating())
      ?.data;
    if (allCreditRatings?.code == 200) {
      result.allCreditRatings = allCreditRatings.data;
    }
    let allPointDrawl = (await pointOfDrawlService.getAllpoint())?.data;
    if (allPointDrawl?.code == 200) {
      result.allPointDrawl = allPointDrawl.data;
    }
    let getNationality = (await nationalityService.getNationality())?.data;
    if (getNationality?.code == 200) {
      result.getNationality = getNationality.data;
    }

    dispatch({ type: SET_INITIAL_REQUIRED_DATA, payload: result });
  } catch (err) {
    console.error("initialCallForRequiredData==>", err);
  }
};
export const initialCallForRequiredDataRoleSpecific = async ({
  reqData,
  dispatch,
}) => {
  let result = {};
  try {
    let specificationTypes = (
      await specificationService.getAllSpecificationTypes()
    )?.data;
    if (specificationTypes?.code == 200) {
      result.specificationTypes = specificationTypes.data;
    }

    let controlAreaTypes = (await controlAreaService.getAllControlArea(reqData))
      ?.data;
    if (controlAreaTypes?.code == 200) {
      result.controlAreaTypes = controlAreaTypes.data;
    }
    dispatch({ type: SET_INITIAL_REQUIRED_DATA, payload: result });
  } catch (err) {
    console.error("initialCallForRequiredData==>", err);
  }
};
const powerValue = localStorage.getItem("powerConsumerValue");
export const registartionRequest = async (data, dispatch) =>
  await apiCall
    .post("/onboarding/signup", data)
    .then((response) => {
      if (response && response?.data?.code === 200) {
        toast.success(response?.data?.message, toastProperties);
        dispatch({ type: IS_REGISTRATION_SUCCESS, payload: true });
        // window.location.replace('/accountVerification'); //redirect to capacity page
        tradeConnectSignup(data);
      }
    })
    .catch((err) => {
      err?.error && toast.error(err.error, toastProperties);
      console.log(err);
    });

export const getAllStateByRegionId = (id, dispatch) => {
  stateCityService
    .getAllState(id)
    .then((response) => {
      if (response && response?.data?.code === 200) {
        dispatch({ type: STATE_OPTIONS, payload: response?.data?.data });
      }
    })
    .catch((error) => {
      console.log("StateOptionsError :", error);
    });
};

export const getDiscomByStateId = (id, dispatch) => {
  discomService
    .getDiscomById(id)
    .then((response) => {
      if (response && response?.data?.code === 200) {
        dispatch({ type: DISCOM_OPTIONS, payload: response?.data?.data });
      }
    })
    .catch((error) => {
      console.log("DiscomOptionsError :", error);
    });
};
export const getAllStatesbyRegionIdforCon = (id, dispatch) => {
  stateCityService
    .getAllState(id)
    .then((response) => {
      if (response && response?.data?.code === 200) {
        dispatch({ type: STATE_CON_OPTIONS, payload: response?.data?.data });
      }
    })
    .catch((error) => {
      console.log("StateOptionsError :", error);
    });
};

export const getDiscomByStateIdforCon = (id, dispatch) => {
  discomService
    .getDiscomById(id)
    .then((response) => {
      if (response && response?.data?.code === 200) {
        dispatch({ type: DISCOM_CON_OPTIONS, payload: response?.data?.data });
      }
    })
    .catch((error) => {
      console.log("DiscomOptionsError :", error);
    });
};

const tradeConnectSignup = (payload) => {
  axios
    .post(
      `${process.env.REACT_APP_API_TRADECONNECT}/onboarding/signup`,
      payload
    )
    .then(function (response) {
      toast.success(response?.data?.message, toastProperties);
    })
    .catch(function (error) {
      error?.error && toast.error(error.error, toastProperties);
    });
};

function postApi2(url, data, headers) {
  return new Promise(function (resolve, reject) {
    axios({
      method: "post",
      url: url,
      headers: headers,
      data: data,
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        console.log({ url, err });
        resolve(err?.response || err);
      });
  });
}